<template>
  <el-dialog title="Cancel Role Matched and Potential Hire" :visible="showModal" :show-close="false" width="600px" class="ts-modal">
    <p>
      Are you sure you want to cancel the process you have started with company <u>{{ jobSeekerInfo.companyName }}</u>
      regarding the role matching for <u>{{ jobSeekerInfo.roleTitle }}</u>?
    </p>
    <p>
      This will cancel the process between you and the employer. <br>
      Your contact and other details will become anoynmous again after the cancellation.        
    </p>
    &nbsp;&nbsp;
    <el-row :gutter="5">
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <button class="ts-btn ts-btn-small" style="float: right;" @click="declineJobMatch">Yes.. Cancel it</button>
      </el-col>
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <button class="ts-btn ts-btn-small ts-btn-white" style="float: left;" @click="onCloseDialog(null)">No.. Go back</button> 
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {  
  created(){
      this.jobSeekerInfo = this.$route.params.data;
    },
  data() {
    return {
      isLoading: false,
      showModal: true,
      jobSeekerInfo: {}
    };
  },
  methods: {
    onCloseDialog(done) {
      this.showModal = false;

      if(this.jobSeekerInfo.isFrom == 'JobSeekerInfoDialog')
        this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "second" }});
      else 
        this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "first" }});
    },
    declineJobMatch() {
      this.$store.dispatch('jobseeker/cancelJobMatch', this.jobSeekerInfo.talentPoolId)
            .then((res) => {
              this.$message.success('Job Match Declined!');
              this.showModal = false;
              this.$router.push({ name: 'jobseeker-statusboard', params: { activeTab: "second" }});
            });
    },
  }
};
</script>